import { jsxs, jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
import BlockerModal from "../components/blocker-modal/blocker-modal.js";
import "react-hook-form";
import "@mui/icons-material/CheckBox.js";
import "@mui/icons-material/CheckBoxOutlineBlank.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/Box/index.js";
import "@mui/material/Checkbox/index.js";
import "lottie-react";
import "../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../components/avatar/avatar.styles.js";
import "../../../../themes/shadows/shadows.js";
import "@mui/material";
import "../../../../themes/typography/typography.js";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../components/avatar-group/avatar-group.styles.js";
import "@mui/system";
import "../../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../type/Translations.js";
import "date-fns/locale";
import "../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "@mui/material/Button/index.js";
import "@mui/material/styles";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../constants/create-theme/create-theme.js";
import "../../../../constants/colors/palette.js";
import "../../../../themes/button/button.js";
import "../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../themes/button/styles/external/filled.styles.js";
import "../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../components/text-field/text-field.styles.js";
import "../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../themes/date-calendar/date-calendar.js";
import "../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../themes/day-calendar/day-calendar.js";
import "../../../../themes/filled-input/filled-input.js";
import "../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../themes/form-label/form-label.js";
import "../../../../themes/month-calendar/month-calendar.js";
import "../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../themes/pickers-day/pickers-day.js";
import "../../../../themes/pickers-month/pickers-month.js";
import "../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../themes/pickers-year/pickers-year.js";
import "../../../../themes/year-calendar/year-calendar.js";
import "../../../../components/dialog/dialog.js";
import "@mui/icons-material/Close.js";
import "../../../../themes/alert/alert.js";
import "../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../themes/dialog/dialog.js";
import "../../../../themes/external-theme/external-theme.js";
import "../../../../constants/breakpoints/breakpoints.js";
import "../../../../themes/checkbox/checkbox.js";
import "../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../themes/form-control-label/form-control-label.js";
import "../../../../themes/radio/radio.js";
import "../../../../themes/switch/switch.js";
import "../../../../themes/popover/popover.js";
import "../../../../themes/tooltip/tooltip.js";
import "../../../../components/dialog/dialog.constants.js";
import "../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../components/icons/all/all.js";
import "../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../components/icons/EventNote/EventNote.js";
import "../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../../components/label/label.styles.js";
import "../../../../components/menu-item/menu-item.js";
import "@mui/material/MenuItem/index.js";
import "../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../components/menu-item/menu-item.styles.js";
import "../../../../components/slider/slider.styles.js";
import "../../../../components/snackbar/snackbar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../components/snackbar/snackbar.types.js";
import "../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "../../../../components/translations/utils.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "../../../../components/time-select/time-select.styles.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../../components/time-interval-select/time-interval-select.js";
import "../../../../components/time-select/time-select.js";
import "@mui/material/InputAdornment/index.js";
import "@mui/material/Typography/index.js";
import "../../../../components/time-interval-select/time-interval-select.styles.js";
import "../../../../components/time-select/time-select.hepers.js";
import "../../../../components/time-interval-select/time-interval-select.helpers.js";
import "../../../../constants/date/date.js";
import "../../appointment-details/assets/icons/Date.js";
import "../../appointment-details/assets/icons/Title.js";
import "../../appointment-details/components/employee-autocomplete/employee-autocomplete.js";
import "@mui/icons-material";
import "../../appointment-details/assets/icons/Employee.js";
import "../../appointment-details/helpers/common.js";
import "date-fns";
import "../../appointment-details/appointment-details.types.js";
import "../../appointment-details/hooks/useEmployeeSearch.js";
import "@tanstack/react-query";
import "../../appointment-details/providers/axios-provider.js";
import "axios";
import "../../appointment-details/components/appointment-form/appointment-form.constants.js";
import "../../appointment-details/components/appointment-form/appointment-form.helpers.js";
import "../../appointment-details/helpers/appointment.js";
import "../../appointment-details/components/employee-autocomplete/employee-autocomplete.skeleton.js";
import "../../appointment-details/components/employee-autocomplete/employee-autocomplete.styles.js";
import "../../../../utils/string/getNameInitials.js";
import "../../../../utils/time/time.js";
import "../appointment-schedule.types.js";
import "../hooks/useBlockerForm.js";
import "@hookform/resolvers/yup";
import "date-fns/startOfToday";
import "yup";
import "../hooks/useSaveBlocker.js";
import "./axios-provider.js";
import "./working-times-provider.js";
import "../helpers/getViewTimePeriod.js";
import "../appointment-schedule.constants.js";
import "../helpers/getEmptyCalendarSlots.js";
import "../helpers/groupBy.js";
import "lodash";
import "../helpers/common.js";
import "fast-memoize";
import "../helpers/fillEmptyDays.js";
import "../hooks/useWorkingTimes.js";
import "../components/blocker-deletion-modal/blocker-deletion-modal.js";
import "../hooks/useDeleteBlocker.js";
import "../components/blocker-deletion-modal/blocker-deletion-modal.styles.js";
import "../components/blocker-modal/blocker-modal.styles.js";
import "@mui/material/FormControlLabel/index.js";
const BlockerModalProviderContext = createContext({ openModal: () => {
}, closeModal: () => {
} });
const BlockerModalProvider = ({
  children,
  clinicReferenceId,
  employees,
  labels,
  language,
  onSaveBlocker,
  onDeleteBlocker
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [initialBlockerData, setInitialBlockerData] = useState();
  const openModal = (element, blocker) => {
    setIsOpen(true);
    setAnchorEl(element);
    setInitialBlockerData(blocker);
  };
  const closeModal = () => {
    setIsOpen(false);
    setInitialBlockerData(void 0);
    setAnchorEl(void 0);
  };
  return /* @__PURE__ */ jsxs(BlockerModalProviderContext.Provider, { value: { openModal, closeModal }, children: [
    isOpen && /* @__PURE__ */ jsx(
      BlockerModal,
      {
        anchorEl,
        clinicReferenceId,
        employees,
        labels,
        blocker: initialBlockerData,
        language,
        onClose: closeModal,
        onSaveBlocker,
        onDeleteBlocker
      }
    ),
    children
  ] });
};
const useBlockerModalProvider = () => {
  const context = useContext(BlockerModalProviderContext);
  if (context === void 0) {
    throw new Error("useBlockerModalProvider must be used within a BlockerModalProvider");
  }
  return context;
};
export {
  BlockerModalProvider,
  useBlockerModalProvider
};
